import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { RouteComponentProps, useParams } from 'react-router';
import { Rate } from 'antd';
import { axius, func, types } from 'utils';
import { Header, IonLoading, OrderButtons } from 'components';

import './_styles.scss';

interface Params { id: string };
interface Props extends RouteComponentProps, types.StateProps { };
const Orders: React.FC<Props> = props => {

    const { _data: { order, location } } = props;

    const [row, setRow] = React.useState<types.Order>({} as types.Order);
    const [loading, setLoading] = React.useState(false);

    const params: Params = useParams();

    React.useEffect(() => {
        if (+order.id === +params.id) {
            setRow(order);
        } else {
            setLoading(true);
            getOrder();
        }
        const orderTimer = setInterval(() => {
            if (![types.OrderStatus.COMPLETED, types.OrderStatus.CANCELLED].includes(row.status)) {
                getOrder();
            } else {
                clearInterval(orderTimer);
            }
        }, 10 * 1000);

        return () => clearInterval(orderTimer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [row.id]);

    const getOrder = () => {
        axius.get(`orders/${params.id}`).then((res: types.AxiusResponse) => {
            if (res.status === 200) {
                setRow(res.data);
                props.dispatch(props.changeData('order', res.data));
            }
            setLoading(false);
        });
    }

    return (
        <IonPage id="Orders">
            <Header {...props} title="Order details" />
            <IonContent>
                <IonLoading open={loading} onCancel={() => setLoading(false)} />
                {row.id && (+row.id === +params.id) && (
                    <div className="p-4s">
                        <div className="p-4">
                            <div className="text-center fw-600 text-muted d-flex justify-content-between align-items-center">
                                <div>#{row.id}</div>
                                <div>
                                    {row.paymentType === types.OrderPaymentTypes.ADVANCE && (
                                        <div className="text-center fw-600s primary">Customer has already paid</div>
                                    )}
                                    {row.paymentType === types.OrderPaymentTypes.DELIVERY && (
                                        <div className="text-center fw-600 primary" style={{ fontSize: 18 }}>₦{func.numberFormat(row.amount.total)}</div>
                                    )}
                                </div>
                            </div>
                            <div className="divider mt-2 mb-3" />

                            {[types.OrderStatus.NEW, types.OrderStatus.PREPARING, types.OrderStatus.READY].includes(row.status) && (
                                <>
                                    <div className="text-uppercase-"><b>Pickup Code:</b></div>
                                    <div className="text-capitalize mb-4">{row.code}</div>
                                </>
                            )}

                            <div className="text-uppercase-"><b>Customer Details:</b></div>
                            <div className="text-capitalize">{row.user?.name}</div>
                            <div className="mb-4">
                                <a href={`tel:${row.user?.phoneNumber}`} className="primary mb-4 ins">{func.format.phoneNumber(row.user?.phoneNumber)}</a>
                            </div>

                            <div className="text-uppercase-"><b>Pick up From:</b></div>
                            <div
                                className="muteds mb-4 primary ins"
                                onClick={() => {
                                    window.open(`https://www.google.com/maps/dir/${location.x},${location.y}/${row.store.address.x},${row.store.address.y}`, `_blank`);
                                }}
                            >{row.store.address?.name}</div>

                            <div className="text-uppercase-"><b>Deliver To:</b></div>
                            <div
                                className="muteds mb-4 primary ins"
                                onClick={() => {
                                    window.open(`https://www.google.com/maps/dir/${location.x},${location.y}/${row.address.x},${row.address.y}`, `_blank`);
                                }}
                            >{row.address?.name}</div>

                            {row.delivery?.instructions && (
                                <>
                                    <div className="text-uppercase-"><b>Instructions:</b></div>
                                    <div className="muteds mb-4">{row.delivery?.instructions}</div>
                                </>
                            )}

                            <div className="text-uppercase- mb-1"><b>Order Details:</b></div>
                            {row.items.map((item: types.Item, i: number) => {
                                let options: string[] = [];
                                Object.keys(item.variants).forEach((po) => {
                                    for (let variant of item.variants[po]) {
                                        options.push(`x${variant.quantity} ${variant.name}${+variant.price ? ` (+${func.numberFormat(variant.price, 2)})` : ''}`);
                                    }
                                });
                                return (
                                    <div key={`${i}_${item.uuid}`} className="d-flex border p-2 rounded mb-2">
                                        {/* <div style={{ width: '4.5vh' }}>
                                            <div className="bg-img" style={{ backgroundImage: `url("${(item.imagesLinks || [])[0] || images.Logo}")`, height: '4.5vh', borderRadius: 4 }} />
                                        </div> */}
                                        <div className="ml-2s">
                                            <span className="fw-600">x{item.quantity}</span> {item.name}
                                            {options.map(option => <div key={option} className="small text-muted pl-2">{option}</div>)}
                                        </div>
                                    </div>
                                )
                            })}

                            <div className="mt-4s">
                                <OrderButtons
                                    item={row}
                                    state={props}
                                    onChange={e => {
                                        setRow(e);
                                        props.dispatch(props.changeData('order', e));
                                    }}
                                />
                            </div>

                            {row.reviews.length > 0 && row.reviews[0].deliveryRate && (
                                <div className="mt-4">
                                    <div className="mb-2"><span className="fw-500">{row.user.firstName}</span> rated you</div>
                                    <Rate defaultValue={row.reviews[0].deliveryRate} disabled />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </IonContent>
        </IonPage>
    );
}

export default Orders;